export default __webpack_public_path__ + "static/media/ic-sort-black-24-px-closed-active.48e5238a.svg";